import React, { useState } from 'react';
import { ReactComponent as CircleArrow } from '../../images/circle-arrow.svg';

import './Accordion.css';

const Accordion = ({ status = true, image, title, children }) => {
  const [isOpen, setIsOpen] = useState(status);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={`accordion ${isOpen ? 'open' : ''}`}
      style={{ marginBottom: '15px' }}
    >
      <div className='accordion-header' onClick={toggleAccordion}>
        <div className='accordion-header-info'>
          {image && (
            <div className='accordion-logo'>
              <img src={image} alt='accordion logo' />
            </div>
          )}
          <h3>{title}</h3>
        </div>
        <span className={`cursor-pointer ${isOpen ? 'down-arrow' : ''}`}>
          <CircleArrow />
        </span>
      </div>
      {isOpen && <div className='accordion-content'>{children}</div>}
    </div>
  );
};

export default Accordion;
